import styled from "styled-components";
import Colors from "../../colors";

export default styled.div`
  flex: 1;
  display: flex;
  
  justify-content: center;
  flex-direction: column;
  padding: 0 20% 100px;

  h1 {
    position: relative;
    font-size: 3.5rem;
    padding-bottom: 10px;
    margin: 10px 0;
    color: ${Colors.secondary};

    &::after {
      position: absolute;
      content: '';
      width: 300px;
      height: 2px;
      bottom: 0;
      left: calc(50% - 150px);
      background-color: ${Colors.main};
    }
  }
`;